import NProgress from 'nprogress';
import router from './index';
import { useUserStore } from '@/store/modules/user';

const WHITE_LIST = ['/login', '/404'];

router.beforeEach(async (to, _from, next) => {
  NProgress.start();
  const title = (to.meta?.title as string) || '';
  const appTitle = import.meta.env.VITE_APP_TITLE || '慧自装 · 管理后台';
  document.title = title ? `${title} - ${appTitle}` : appTitle;

  const user = useUserStore();
  if (WHITE_LIST.includes(to.path) || to.meta?.anonymous) {
    if (to.path === '/login' && user.token) return next({ path: '/' });
    return next();
  }
  if (!user.token) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }
  if (!user.loaded) {
    try {
      await user.fetchProfile();
    } catch {
      // fetchProfile 任何失败 (CORS / 网络 / token 失效) 都清登录态,
      // 否则下一次 guard 看 token 还在仍会从 /login 弹回 / → 死循环
      await user.logout(true);
      return next({ path: '/login' });
    }
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});
